import React from "react";
import { useTranslation } from "locales";
import useAuthUser from "hooks/useAuthUser";
import BasePage from "components/BasePage";
import BlockHowItWorks from "components/BlockHowItWorks";
import InfiniteScroll from "components/InfiniteScroll";
import BaseFilters from "./components/BaseFilters";
import BlockBecomeACoach from "./components/BlockBecomeACoach";
import BlockRecommendationToContactUs from "./components/BlockRecommendationToContactUs";
import PerformerList from "./components/PerformerList";
import useController from "./controller";
import "./style.scss";

interface Props {
  onlyFollowings?: boolean;
}

function PagePerformers({ onlyFollowings = false }: Props) {
  const { users, loading, scroll, loadMore, filtersDTO, setFilters, totalRecords, userFavoriteIds } = useController({
    onlyFollowings,
  });
  const { t } = useTranslation();
  const { user } = useAuthUser();

  const description = (
    <div className="block-services__description subtitle-1 text-neutral-darken-1 mt-4">
      {t(
        "Our coaches are finance professionals from top banks and funds. Their real-world insight and expertise turn preparation into offers."
      )}
    </div>
  );

  return (
    <BasePage loading={loading} className="page-performers">
      <BlockHowItWorks prepend={description} />
      <BlockRecommendationToContactUs />
      <div className="page-performers__content">
        <div className="page-performers__header d-flex __align-center mb-10 text-center">
          <h2 className="h2">{t("Find a coach")}</h2>
          <div className="subtitle-1 text-neutral-darken-1">
            {t("Refine your search to find the best-fit coach for your goals.")}
          </div>
        </div>
        <BaseFilters filtersDTO={filtersDTO} setFilters={setFilters} totalRecords={totalRecords} />
        {users.length > 0 && (
          <InfiniteScroll enable={scroll} onNext={loadMore}>
            <PerformerList users={users} userFavoriteIds={userFavoriteIds} />
          </InfiniteScroll>
        )}
        {!loading && users.length === 0 && (
          <div className="d-center headline-2" style={{ height: "100%" }}>
            {t("No matching result found")}
          </div>
        )}
      </div>
      {!user && <BlockBecomeACoach />}
    </BasePage>
  );
}

export default PagePerformers;
